import axios from "axios";

import ConvertObjectParamToString from "@/commons/ConvertObjectParamToString";

export default class FeeTrackingKSService {
	private convertObjectParamToStrings: ConvertObjectParamToString = ConvertObjectParamToString.instance;
	public getAllCompanies(): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.get("/api/business/companyList")
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	public getAllCompaniesV2(querySearch): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.get("/api/business/v2/companyList", {
					params: querySearch,
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	}

	public SearchDecision(querySearch: any, cancelToken): Promise<any> {
		return new Promise<any>((resolve, reject) => {
			axios
				.get("/api/business/decision-searchs" + "?" + this.convertObjectParamToStrings.convertObjectParamToStrings(querySearch), {
					cancelToken: cancelToken.token,
				})
				.then((res) => {
					resolve(res.data);
				})
				.catch((err) => {
					console.log(reject(err));
				});
		});
	}

	public excelTlm(param?: any, querySearch?: any): Promise<any> {
		let url = "/api/business/decision/export/excel?year=" + param.year + "&quarter=" + param.quarter;
		return new Promise<any>((resolve, reject) => {
			axios
				.post(url, querySearch, { responseType: "blob" })
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.log(reject(err));
				});
		});
	}
}
